import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface PageHeaderProps {
  title: string;
  backTo?: string;
  backLabel?: string;
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({
  title,
  backTo,
  backLabel = "戻る",
  actions,
  className,
}: PageHeaderProps): JSX.Element {
  return (
    <header
      className={cx(
        "flex flex-col gap-3 border-b border-border pb-4 md:flex-row md:items-center md:justify-between",
        className,
      )}
    >
      <div>
        {backTo !== undefined && (
          <Link
            to={backTo}
            className="mb-2 inline-flex text-sm font-medium text-primary hover:text-primary-hover"
          >
            {backLabel}
          </Link>
        )}
        <h1 className="text-2xl font-semibold leading-tight text-text-primary">{title}</h1>
      </div>
      {actions !== undefined && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </header>
  );
}

function cx(...classes: Array<string | false | undefined>): string {
  return classes.filter(Boolean).join(" ");
}
